import React from 'react'
import { Link } from 'react-router-dom';

const LinkRetorno = (props) => {
  if (props.urlRetorno) {
    return (<Link to={props.urlRetorno}>
      <i className="material-icons custom-icons">
        &#xe5c4;
      </i>
    </Link>)
  }
  return '';
}

export default LinkRetorno
